"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var IdReg = /^([OU]:)(\w+)(?:(:)(\w+))?$/;
exports.twilioUtils = {
  userPrefix: "U:",
  organizationPrefix: "O:",
  getAppUserId: function getAppUserId(userId) {
    return "".concat(this.userPrefix).concat(userId);
  },
  getOrganizationId: function getOrganizationId(orgId) {
    return "".concat(this.organizationPrefix).concat(orgId);
  },
  getOrgUserId: function getOrgUserId(orgId, orgUserId) {
    return "".concat(this.organizationPrefix).concat(orgId, ":").concat(orgUserId);
  },
  parseId: function parseId(id) {
    var match = IdReg.exec(id);
    if (match == null) throw Error("Wrong Twilio User Id");
    var isOrganization = match[1] == this.organizationPrefix;

    if (!isOrganization) {
      return {
        isOrganization: isOrganization,
        isUser: !isOrganization,
        id: match[2]
      };
    } else {
      if (match[4] == null) throw Error("Wrong Twilio orgUser Id");
      return {
        isOrganization: isOrganization,
        isUser: !isOrganization,
        id: match[2],
        orgUserId: match[4]
      };
    }
  }
};